// src/components/shared/modals/AddOtherCreditModal.tsx
// Wrapper around UnifiedCourseModal for the Other Credits section.

import UnifiedCourseModal from './UnifiedCourseModal';

export interface PLCInfo {
  total_plc: number;
  remaining: number;
  plc_cap: number;
}

interface OtherCreditCourseInput {
  type?: string;
  code?: string;
  course_id?: number;
  title?: string;
  credits?: number;
  grade?: string | null;
  sourceType?: string;
  source_type?: string;
  institution?: string;
  notes?: string;
  requirements?: Record<string, unknown>;
  gen_ed?: unknown;
  gen_ed_area?: unknown;
  gen_ed_requirements?: unknown;
  [key: string]: unknown;
}

export interface CourseCreditPayload {
  type: 'umd_course';
  course_code?: string;
  course_id?: number;
  title?: string;
  credits?: number;
  grade: string | null;
  source_type: 'other_credits';
  [key: string]: unknown;
}

export interface PlaceholderCreditPayload {
  type: 'placeholder';
  title?: string;
  credits?: number;
  grade: string | null;
  source_type?: string;
  institution?: string;
  notes?: string;
  requirements?: Record<string, unknown>;
  gen_ed?: unknown;
  gen_ed_area?: unknown;
  gen_ed_requirements?: unknown;
  [key: string]: unknown;
}

export type OtherCreditPayload = CourseCreditPayload | PlaceholderCreditPayload;

export interface AddOtherCreditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (creditData: OtherCreditPayload) => Promise<void> | void;
  plcInfo?: PLCInfo;
}

const AddOtherCreditModal = ({
  isOpen,
  onClose,
  onSubmit,
  plcInfo = { total_plc: 0, remaining: 60, plc_cap: 60 },
}: AddOtherCreditModalProps) => {
  const handleSubmit = async (courseData: Record<string, unknown>): Promise<void> => {
    const data = courseData as OtherCreditCourseInput;
    let creditData: OtherCreditPayload;

    if (data.type === 'umd_course') {
      creditData = {
        type: 'umd_course',
        course_code: data.code,
        course_id: data.course_id,
        title: data.title,
        credits: data.credits,
        grade: data.grade || null,
        source_type: 'other_credits',
      };
    } else {
      creditData = {
        type: 'placeholder',
        title: data.title,
        credits: data.credits,
        grade: data.grade || null,
        source_type: data.sourceType || data.source_type,
        institution: data.institution,
        notes: data.notes,
        requirements: data.requirements,
        gen_ed: data.gen_ed,
        gen_ed_area: data.gen_ed_area,
        gen_ed_requirements: data.gen_ed_requirements,
      };
    }

    await onSubmit(creditData);
  };

  return (
    <UnifiedCourseModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      context="other_credits"
      plcInfo={plcInfo}
    />
  );
};

export default AddOtherCreditModal;
